<template>
  <div class="page-container">
    <div class="data-filter">
        <el-button size="mini" type="primary" @click="functionSave">저장하기</el-button>
    </div>
    <div class="data-table">
        <el-form ref="" :model="form">
            <el-table class="lmm-table" :data="list" v-loading="loading" stripe border>
                <el-table-column type="index" :index="rowIndex" width="100"></el-table-column>
                <el-table-column label="파일전송 기능">
                    <template slot-scope="scope">
                      <el-switch v-model="scope.row.global_filetransfer"></el-switch>
                      <!-- <el-input v-model="scope.row.global_filetransfer"></el-input> -->
                      <span style="margin-left:30px;">
                          관리자, 매니저, 사용자 생성 시 파일전송 기능을 사용합니다.
                      </span>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
      async getFunction () {
        console.log('GET GLOBAL_TRANSFER')

        try {
          this.loading = true

          let response = await this.$http.get('global_filetransfer')
          this.list = response.data

          this.loading = false
          
          return response
        }
        catch (e) {
          console.error(e)
        }
      },
      rowIndex (index) {
          return index + 1
      },
      async functionSave () {
        let params = this.list[0]
        let {status} = await this.$http.post('global_filetransfer', params)
        if (status === 200) {
            this.$service.$emit('alert-modal', '클라이언트 버전 정보가 수정되었습니다.')
        }else{
          console.log('error')
        }
      }
    },
    mounted () {
      this.getFunction()
    },
    data () {
        return {
            loading: false,
            dialog_notice: false,
            dialog_notice_option: null,
            list: [],
            form: {},
            tableData: [
                {
                    function: true
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.data-filter {
  padding: 10px 0;
  .data-filter-buttons {
    display: inline-block;
  }
  .data-filter-search {
    display: inline-block;
    padding-left: 15px;
  }
}
</style>